import { sourceConstant } from "../../../NewConstants/SourceDialogConstants";
import { trackEvent } from "../../../Actions/Utils";

const SourceDialog = ({
  selectedLanguage,
  sourceLanguage,
  sourceData,
  closeDialog = () => { },
  openPdfViewer = () => { },
}) => {

  const getPageString = (pagesArr) => {
    const pagesCopy = [...pagesArr];
    if (pagesCopy.length === 0) {
      return "";
    } else if (pagesCopy.length === 1) {
      return sourceConstant.page[selectedLanguage] + " " + pagesCopy[0];
    } else {
      const lastElement = pagesCopy.pop();
      return sourceConstant.page[selectedLanguage] + " " + pagesCopy.join(", ") + " " + sourceConstant.and[selectedLanguage] + " " + lastElement;
    }
  };

  const getPageArray = (source) => {
    let pages = [];
    if (Array.isArray(source.raw_pdf_page) && source.raw_pdf_page.length > 0) {
      pages = source.raw_pdf_page;
    } else if (Array.isArray(source.page) && source.page.length > 0) {
      pages = source.page;
    }
    if (!Array.isArray(pages) || pages.length === 0) {
      pages = [1];
    }
    return pages;
  };

  const handleSourceClick = (source) => {
    if (openPdfViewer) {
      openPdfViewer(source);
      closeDialog();
    }
    trackEvent("source_link_clicked", "Click", "Number of times user clicked on source links");
  };

  return (
    <div>
      <div className="fixed inset-0 bg-gray-800 opacity-50"></div>
      <div className="fixed inset-0 flex items-center justify-center p-2">
        <div className="max-h-[80vh] h-fit relative bg-[var(--neutral-white)] p-6 rounded-lg shadow-xl w-[90%]">
          <div className="relative overflow-hidden h-full">
            <div className="flex flex-col items-center justify-center mb-4">
              <div className="text-[1rem] leading-9 font-[300]">
                {sourceConstant.subtitle[selectedLanguage]}
              </div>
            </div>
            <div className="overflow-y-auto max-h-[60vh] h-fit">
              {sourceData.map((source, idx) => {
                return (
                  <div
                    key={idx}
                    className="flex items-center justify-between bg-[var(--light-neutral-2)] border-[var(--link-blue)] rounded-lg border-2 pl-4 pr-5 py-6 mb-4"
                    onClick={() => handleSourceClick(source)}
                  >
                    <div className="flex flex-col justify-center items-start">
                      <div className="font-[300] text-[var(--dark-neutral-2)] text-lg">
                        {getPageString(getPageArray(source))}
                      </div>
                      <div className="underline text-[var(--link-blue)] font-[600] text-xl">
                        {source?.en_source}
                      </div>
                    </div>
                    <div>
                      <img
                        className="h-8"
                        src={"./Assets/Images/externalLink.svg"}
                        alt="link"
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div
            className="absolute top-[-1.25rem] right-[-1.25rem] rounded-full bg-[var(--almost-black)] flex items-center justify-center p-1"
            onClick={closeDialog}
          >
            <img src={"./Assets/Images/crossIcon.svg"} alt="close" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SourceDialog;
